import HTTP from '@/api/HTTP';
import transform from '@/services/presse/sponsoring/produitSponsoringServerTableDataTransformer';

const URL_BASE = 'gescom/ProduitSponsoring/';

export async function create(produit) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', produit);
  return response;
}

export async function update(produit) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', produit);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id } });
  return response;
}

export async function copieAsync(id, libelleCopiePrefixe) {
  const response = await HTTP.post(URL_BASE + 'CopieAsync', { id: id, libelleCopiePrefixe: libelleCopiePrefixe });
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { id: id, archiver: status });
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}
